import { render } from "./StreetAddressesApartments.vue?vue&type=template&id=4cdcbd01&ts=true"
import script from "./StreetAddressesApartments.vue?vue&type=script&lang=ts"
export * from "./StreetAddressesApartments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__